import { render, staticRenderFns } from "./CellRendererEmail.vue?vue&type=template&id=b24d1e40&scoped=true&"
import script from "./CellRendererEmail.vue?vue&type=script&lang=js&"
export * from "./CellRendererEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24d1e40",
  null
  
)

export default component.exports